<script>
    import WhiteButton from "../components/WhiteButton.svelte";
    import ModalService from "../services/ModalService";

    let container;

    import {onMount} from "svelte";

    function fadeBody() {
        document.querySelector('body').style.background = 'none';
        document.querySelector('body').style.backgroundColor = '#333333';
        container.querySelector('button').style.background = '#FE520A';
        container.querySelector('button').style.color = '#FFFFFF';
        container.querySelector('button').style.borderColor = '#FE520A';
        //Todo, style this with css, I'm too tired at this point to do it right, no regrets - Cody ;)
        // Update, one year later, still not feeling any regret
        container.querySelector('button').style.marginTop = '56px';
        container.querySelector('span').style.marginTop = '20px';
    }

    onMount(function () {
        fadeBody();
    })

</script>

<style>
    section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 30vh;
        text-align: center;
    }
    span {
        margin: 0 20px 0 20px;
    }
</style>

<section bind:this={container}>
    <h1>This message is toast.</h1>
    <span>BURN links self-destruct after they are viewed the first time. This message no longer exists.</span>
    <WhiteButton click={ModalService.about}>Learn More</WhiteButton>
</section>
